<template>
  <div class="about-block">
    <div class="banner">
      <div class="container-block">
        <div class="info">
          <h1>关于我们</h1>
          <p>科研圈内人--让科研人员专注于科学本身！</p>
        </div>
        <div class="order">
          <img src="@/assets/imgs/icon2.png" />
          <p>订单累计：{{ total }}</p>
        </div>
      </div>
    </div>

    <Breadcrumb />

    <div class="container-block">
      <div class="card-block">
        <div class="title">
          <img src="@/assets/imgs/icon24.png" />
          <span>我们的愿景</span>
          <div>Our vision</div>
        </div>

        <div class="vision-block">
          <el-row :gutter="20">
            <el-col :span="8">
              <div class="circular">
                <img alt src="@/assets/imgs/icon25.png" />
              </div>
              <p>让科学家专注于科研本身</p>
            </el-col>
            <el-col :span="8">
              <div class="circular color-green">
                <img alt src="@/assets/imgs/icon26.png" />
              </div>
              <p>Right People Right Papers!</p>
            </el-col>
            <el-col :span="8">
              <div class="circular color-orange">
                <img alt src="@/assets/imgs/icon27.png" />
              </div>
              <p>Let Scientists Focus on Science!</p>
            </el-col>
          </el-row>

          <div>
            <el-row>
              <el-col :span="8">
                <img alt class="certificate" src="@/assets/imgs/logo.png" />
              </el-col>
              <el-col :span="8">
                <img
                  alt
                  class="certificate"
                  src="@/assets/imgs/certificate1.png"
                />
              </el-col>
              <el-col :span="8">
                <img
                  alt
                  class="certificate"
                  src="@/assets/imgs/logo-footer2.png"
                />
              </el-col>
            </el-row>
          </div>
        </div>

        <div class="title">
          <img src="@/assets/imgs/icon3.png" />
          <span>联系我们</span>
          <div>Contact us</div>
        </div>

        <div class="contact-block">
          <el-row :gutter="20">
            <el-col :span="12">
              <p>
                办公地址：
                北京市海淀区中关村南三街6号中科资源大厦裙楼518房间【中科院海外人才创业园】
              </p>
              <p>联系人：杨编辑</p>
              <p>联系电话： 15611822557</p>
              <p>Email： service@pandaedit.com</p>
              <!-- <p>Email： <a href="" target="_blank">service@pandaedit.com</a></p> -->
              <p>QQ号：1804232143</p>

              <el-row :gutter="20">
                <el-col :span="12">
                  <p>信达雅科教服务号</p>
                  <img src="@/assets/imgs/wechat2.png" />
                </el-col>

                <el-col :span="12">
                  <p>PEN论文服务客服微信号</p>
                  <img src="@/assets/imgs/wechat3.jpg" />
                </el-col>

                <el-col :span="24">
                  <p>“科研圈内人”顶级学术报告订阅号</p>
                  <img src="@/assets/imgs/wechat4.png" />
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="12">
              <!--百度地图-->
              <baidu-map
                :center="mapCenter"
                :scroll-wheel-zoom="true"
                :zoom="mapZoom"
                @click="getClickInfo"
                @ready="handler"
                style="height: 500px"
              ></baidu-map>
            </el-col>
          </el-row>
        </div>

        <div class="title">
          <img src="@/assets/imgs/icon3.png" />
          <span>财务信息</span>
          <div>Financial Information</div>
        </div>
        <div class="contact-block">
          <el-row :gutter="20">
            <el-col :span="8">
              <div class="align-center">
                <p>
                  A. 对公账户（用于对公汇款） 户名：北京文雅信达科技有限公司
                  招商银行北京金融街支行账号： 110936956910201
                </p>
              </div>
            </el-col>

            <el-col :span="8">
              <div class="align-center">
                <p>B. 聚合收款码（可用公务卡）</p>
                <img style="margin: 0 auto" src="@/assets/imgs/bank-quankuan.png" />
              </div>
            </el-col>

            <el-col :span="8">
              <div class="align-center">
                <p>C.支付宝收款码（用于缴纳押金或自费用户）</p>
                <img style="margin: 0 auto" src="@/assets/imgs/alipay-geren.png" />
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * @description 关于我们
 */
import * as api from '@/api/user'
// import * as commonFunc from '@/utils/common-func'
import Breadcrumb from '@/components/Breadcrumb'

export default {
  name: 'About',
  components: {
    Breadcrumb
  },
  data() {
    return {
      total: 0, // 订单总量
      mapCenter: { lng: 116.334625, lat: 39.990556 },
      mapZoom: 13
    }
  },
  created() {
    this.getOrderTotal() // 获取订单总数
  },
  methods: {
    /**
     * @description 获取订单总数
     */
    getOrderTotal() {
      const _this = this
      const _param = {}
      api
        .orderTotal(_param)
        .then((res) => {
          const _data = res.data

          _this.total = _data.order_total || 0
        })
        .catch((err) => {
          console.log(err)
          // _this.$message.error('操作失败，请稍后刷新页面再试！')
        })
    },

    /**
     * @description 百度地图初始化
     */
    handler({ BMap, map }) {
      var point = new BMap.Point(116.334625, 39.990556)
      map.centerAndZoom(point, 13)
      var marker = new BMap.Marker(point) // 创建标注
      map.addOverlay(marker) // 将标注添加到地图中
      var circle = new BMap.Circle(point, 6, {
        strokeColor: 'Red',
        strokeWeight: 6,
        strokeOpacity: 1,
        Color: 'Red',
        fillColor: '#f03'
      })
      map.addOverlay(circle)
    },
    getClickInfo(e) {
      this.mapCenter.lng = e.point.lng
      this.mapCenter.lat = e.point.lat
    }

    //     /**
    //  * @description 获取角色列表
    //  */
    // getListByPage() {
    //   const _this = this
    //   _this.tableLoading = true
    //   const _param = {
    //     page: _this.pageparm.page,
    //     size: _this.pageparm.size,
    //     roleName: _this.pageparm.roleName,
    //     orgid: _this.pageparm.orgid
    //   }
    //   api.listByPage(_param)
    //     .then(res => {
    //       const data = res.data
    //       _this.tableLoading = false
    //       _this.listData = data.result
    //       _this.pageparm.total = data.pageTotalCount
    //     })
    //     // .catch(err => {
    //     // })
    // },
  }
}
</script>
<style lang="scss" scoped>
.about-block {
  .banner {
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
    background-image: url('../../assets/imgs/banner1.png');
    height: 336px;
    color: #ffffff;

    p {
      font-size: 18px;
    }

    .container-block {
      height: 336px;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    .info {
      color: #ffffff;
      margin-left: 60px;

      h1 {
        font-size: 38px;
      }
    }

    .order {
      margin-right: 220px;
    }
  }

  .card-block {
    // width: 100%;
    padding: 20px;
    margin: 20px 0 40px 0;
    background: #ffffff;
    border: 1px solid #dfdfdf;
    -moz-box-shadow: 15px 15px 0 #dddddd; /* 老的 Firefox */
    box-shadow: 15px 15px 0 #dddddd;

    .title {
      display: flex;
      align-items: center;
      font-size: 24px;
      padding: 0 20px 20px 20px;
      border-bottom: 1px solid #dcdfe6;

      img {
        display: block;
        width: 30px;
        margin: 0 10px 0 0;
      }

      & > div {
        font-size: 14px;
        color: #98a5a6;
        margin: 0 0 0 10px;
      }
    }

    .vision-block {
      margin: 100px 0;

      p {
        font-size: 22px;
        text-align: center;
        margin: 30px 0 0 0;
      }

      .circular {
        width: 200px;
        height: 200px;
        border-radius: 50%;
        background: #58bae8;
        margin: 0 auto;
        display: flex;
        align-items: center;
        justify-content: center;

        img {
          display: block;
          max-width: 120px;
        }
      }

      .color-green {
        background: #5cc189;
      }

      .color-orange {
        background: #e7a13c;
      }

      .certificate {
        margin: 80px auto 0 auto;
        display: block;
        height: 152px;
        // max-width: 400px;
      }
    }

    .contact-block {
      margin: 50px 0 0 20px;

      p {
        font-size: 20px;
        color: #98a5a6;
        line-height: 1.6;
        margin: 0 0 20px 0;
      }

      a {
        color: $colorNormal;
      }

      img {
        display: block;
        width: 200px;
        margin: 0 0 20px 0;
      }
    }
  }
}
</style>